const features = [
  {
    icon: 'ri-flashlight-line',
    title: '每日更新追踪',
    desc: '每日大赛入口坚持每日更新，运营团队实时追踪各大平台最新大赛动态，确保每日大赛列表始终保持新鲜度。',
  },
  {
    icon: 'ri-stack-line',
    title: '30+ 大赛类型覆盖',
    desc: '从舞蹈音乐到编程设计，每日大赛类型覆盖广泛，每日大全帮你一站式浏览全部大赛赛道。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '精准作品介绍',
    desc: '每篇每日大赛作品介绍都经过精心整理，提炼核心亮点，让你快速了解作品内容和赛事背景。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端便捷访问',
    desc: '每日大赛入口适配桌面与移动端，随时随地浏览每日大赛在线内容，发现感兴趣的大赛视频。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          平台特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          每日大赛入口的核心优势，为你提供更好的大赛内容浏览体验
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="rounded-xl border border-background-200/70 bg-background-50 p-6 text-center transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className={`${feat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}